module.exports = __webpack_public_path__ + "img/img37.ffb6dc9a.svg";